import { useNavigate } from "react-router-dom";

export const BacktoPrevious = ({ className = "" }) => {
  const navigate = useNavigate();
  return (
    <div className={className}>
      <div className="backAccount myAccount-back mt-3">
        <a
          role="button"
          tabIndex={0}
          onClick={(e) => {
            e.preventDefault();
            navigate(-1);
          }}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              navigate(-1);
            }
          }}
        >
          <i className="fa-solid fa-chevron-left" /> Back
        </a>
      </div>
    </div>
  );
};
